import React, { memo, useCallback } from 'react';

import { Card, Space, Typography, Icon } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';

import { IProductData } from '../../types/productBlock';
import { makeAttribute } from '../../utils/attribute';

import styles from './ProductCard.module.scss';

type ProductCardProps = {
  productData: IProductData;
  isMobile?: boolean;
  onClick: (url: string, eventCategory: string, eventLabel?: string) => void;
};

export const ProductCard = memo<ProductCardProps>(({ productData, isMobile, onClick }) => {
  const cx = useStyles(styles);
  const textWrapperClassNames = cx({
    textWrapper: productData.picture,
  });

  const pictureClassNames = cx('pictureContainer', {
    [`img-product-${productData.key}`]: productData.key,
    [`img-product-${productData.key}-mobile`]: isMobile && productData.key,
  });

  const handleCardClick = useCallback(() => {
    onClick(productData.pageUrl, productData.eventCategory, productData.eventLabel);
  }, [productData, onClick]);

  return (
    <Card size={16} className={cx('card')} onClick={handleCardClick} color={productData.cardColor || 'dark'}>
      <Space direction="vertical" size={4}>
        {!!makeAttribute(productData.icon, isMobile) && <Icon icon={makeAttribute(productData.icon, isMobile)} />}
        <Space className={textWrapperClassNames} direction="vertical" size={4}>
          {productData.title &&
            (typeof productData.title === 'string' ? (
              <Typography.Heading level={6} className={cx('cardTitle')}>
                {productData.title}
              </Typography.Heading>
            ) : (
              productData.title
            ))}
          {makeAttribute(productData.subtitle, isMobile) && (
            <Typography.Text size={10} className={cx('cardSubtitle')}>
              {makeAttribute(productData.subtitle, isMobile)}
            </Typography.Text>
          )}
        </Space>
        <Space className={cx('iconWrapper')} justify={productData.badge ? 'space-between' : 'end'} align="center">
          {productData.badge && productData.badge}
        </Space>
      </Space>
      {productData.picture && (
        <div className={pictureClassNames}>
          <picture>{productData.picture}</picture>
        </div>
      )}
    </Card>
  );
});
